"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var baseViewModel_1 = require("./base/baseViewModel");
var Clipboard = require("clipboard");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel() {
        _super.call(this);
        var urlClipboard = new Clipboard("#workSeriesUrl");
        urlClipboard.on("success", function () {
            alert("Ссылка на цикл произведений скопирована.");
            app.closeModal();
        });
        urlClipboard.on("error", function (e) {
            var $el = $(e.trigger);
            var url = $el.attr("data-clipboard-target");
            prompt("Ссылка на цикл произведений", url);
            app.closeModal();
        });
    }
    ViewModel.prototype.showAuthModal = function () {
        app.ensureAuth("Только зарегистрированные пользователи могут купить цикл, книгу или подарить награду.", true);
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=workSeriesView.js.map